import styled from 'styled-components';

export const AccordeonHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  align-items: center;
  height: 53px;
  background: #4948ac 0% 0% no-repeat padding-box;
  cursor: pointer;
`;

export const AccordeonHeaderTitle = styled.div`
  font: normal normal normal 24px/36px Biotif;
  color: #ffffff;
`;

export const AccordeonContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px;
  gap: 10px;
  padding: 30px;
`;

export const HeaderInfo = styled.div`
  display: flex;
  justify-content: flex-end;
  font-family: BiotifSemiBold;
`;

export const HeaderContent = styled.div`
  display: flex;
  gap: 30px;
`;

export const FixedPriceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: BiotifSemiBold;
`;

export const FixedPriceContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  gap: 10px;
  height: 500px;
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const FixedPriceLine = styled.div`
  display: flex;
  gap: 30px;
  label {
    font: normal normal bold 16px Biotif;
    color: #9399b2;
  }
`;

export const Arrow = styled.img`
  margin-left: 30px;
  height: 7px;
  width: auto;
`;

export const HorizontalLine = styled.div`
  flex-grow: 1;
  border-bottom: 1px solid #4948ac;
  align-self: center;
  margin: 10px;
`;
